export enum ApplicationUpdateMessage {
  WELCOME_BACK = 'WELCOME_BACK',
  HAS_APPROVAL = 'HAS_APPROVAL',
  TERMS_UPDATED = 'TERMS_UPDATED',
  EDOCS_SIGNED = 'EDOCS_SIGNED',
  LENDER_FUNDED = 'LENDER_FUNDED',
}
